import { Injectable, signal, computed } from '@angular/core';

/**
 * Manages the header display mode across the app.
 *
 * - null  → main header (logo + notifications + user menu) + bottom nav visible
 * - string → secondary header (← back + translated title) + bottom nav hidden
 *
 * The mobile layout reads this state on every NavigationEnd event using the
 * `headerTitle` data property declared in each route.
 */
@Injectable({ providedIn: 'root' })
export class HeaderStateService {
    private _titleKey = signal<string | null>(null);

    readonly titleKey = this._titleKey.asReadonly();
    readonly isSecondary = computed(() => this._titleKey() !== null);

    set(key: string | null): void {
        this._titleKey.set(key);
    }
}
